import { Component, OnDestroy, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';

import { LoaderService } from '../../../core/layout/loader/loader.service';
import { WidgetDashboardComponent } from '../../widgets/components/widget-dashboard/widget-dashboard.component';

@Component({
  selector: 'carehub-home',
  standalone: true,
  imports: [CardModule, WidgetDashboardComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, OnDestroy {
  constructor(public loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.disable();
  }

  ngOnDestroy(): void {
    this.loaderService.enable();
  }
}
